export default __webpack_public_path__ + "37f8d10c9c15ad8431129b5419ec3561.jpg";